import multiSelectItems from './multiSelectGeneralItems.html';

(function () {
  angular.module('7Shop.Common')
    .directive('sMultiSelectGeneralItems', sMultiSelectGeneralItems);

  function sMultiSelectGeneralItems() {
    return {
      scope: {
        items: '=',
        onItemToggle: '&'
      },
      templateUrl: multiSelectItems,
      link: function (scope) {
        scope.toggleSelect = function () {
          this.selected = !this.selected;
          scope.onItemToggle();
        };
      }
    };
  }
})();
